/*
 * Copyright (c) 2025. Bolmate B.V.
 */
import './style/productReviewAnalyse.scss';

import React, {MouseEventHandler} from 'react';
import {ProductReviewAnalyse} from "../../../../util/interfaces";
import {DotsLoader} from "../../../controls/loader/dotsLoader";
import BolmatePlaceholderOverlay from "../../../misc/bolmatePlaceholderOverlay";
import classNames from 'classnames';
import {BolmateButton} from "../../../controls";
import Image from "../../../misc/image";
import {AwesomeIcon} from '@dvrd/dvr-controls';

interface Props {
    onAnalyse: MouseEventHandler;
    loading: Record<ProductReviewAnalyse, boolean>;
    result: Record<ProductReviewAnalyse, string | null>;
}

function getAnalysisTitle(analysisType: ProductReviewAnalyse): string {
    return {
        [ProductReviewAnalyse.POSITIVE]: 'Positieve punten',
        [ProductReviewAnalyse.NEGATIVE]: 'Negatieve punten',
        [ProductReviewAnalyse.IMPROVEMENTS]: 'Verbeterpunten',
        [ProductReviewAnalyse.TARGET]: 'Typische doelgroep',
        [ProductReviewAnalyse.CUSTOMERS]: 'Klant persona'
    }[analysisType];
}

export default function ProductReviewsAnalyse(props: Props) {
    const {onAnalyse, loading, result} = props;

    function renderAnalysis(analysisType: ProductReviewAnalyse, withButton: boolean = false) {
        const content = result[analysisType];
        const isLoading = loading[analysisType];
        return (
            <div className='analysis-container'>
                <div className='analysis-header'>
                    <label className='analysis-title'>BolmateAI - {getAnalysisTitle(analysisType)}</label>
                </div>
                <div className='analysis-content'>
                    {!content && <BolmatePlaceholderOverlay
                        className={classNames('analysis-overlay', (withButton || isLoading) && 'without-image')}/>}
                    {(!content && !isLoading && withButton) && renderButton()}
                    {isLoading && <DotsLoader dotSize='4rem' className='analysis-loader' noSmile/>}
                    {!!content && <div className='analysis-result' dangerouslySetInnerHTML={{__html: content}}/>}
                </div>
            </div>
        )
    }

    function renderButton() {
        return (
            <BolmateButton onClick={onAnalyse} label='Analyseren met BolmateAI' className='btn-analyse'
                           ornaments={{
                               element: <Image name='logo-no-text' alt='' style={{
                                   maxWidth: '1.2rem', maxHeight: '1.2rem', objectFit: 'scale-down'
                               }}/>
                           }} secondary/>
        )
    }

    return (
        <div className='product-review-analysis'>
            {renderAnalysis(ProductReviewAnalyse.POSITIVE, true)}
            {renderAnalysis(ProductReviewAnalyse.NEGATIVE)}
            {renderAnalysis(ProductReviewAnalyse.IMPROVEMENTS)}
            {renderAnalysis(ProductReviewAnalyse.TARGET)}
            {renderAnalysis(ProductReviewAnalyse.CUSTOMERS)}
        </div>
    )
}